<template>
    <div>
        <b-modal id="m-input-barang-masuk-external-emas" title="Input Barang Masuk External Emas" size="xl" no-close-on-backdrop
            no-close-on-esc hide-footer @show="init()">
            <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
            <div v-else>
                <b-row class="mt-3">
                    <b-col md="6">
                        <div>
                            <div class="font-weight-bold">Jenis Barang</div>
                            <div id="jenis-barang">
                                <multiselect v-model="input.kind" :allow-empty="false" label="name" track-by="id"
                                    :internal-search="true" @input="fetchMerkBarang" placeholder="-- Pilih Salah Satu --"
                                    :options="kinds" />
                            </div>
                        </div>
                        <div>
                            <div class="font-weight-bold mt-3">Tipe Barang</div>
                            <div id="tipe-barang">
                                <multiselect :disabled="fetch || !input.brand" v-model="input.type" :allow-empty="false" label="name"
                                    track-by="id" :internal-search="true" placeholder="-- Pilih Salah Satu --" :options="types"
                                    />
                            </div>
                        </div>
                    </b-col>
                    <b-col md="6">
                        <div class="font-weight-bold">Merk Barang</div>
                            <div id="merk-barang">
                                <multiselect :disabled="fetch || !input.kind" v-model="input.brand" :allow-empty="false" label="name"
                                    track-by="id" :internal-search="true" @input="fetchTipeBarang"
                                    placeholder="-- Pilih Salah Satu --" :options="brands"/>
                            </div>
                        <div>
                            <div class="font-weight-bold mt-3">Source</div>
                            <multiselect :disabled="fetch" v-model="input.source" :allow-empty="false" label="name"
                                track-by="id" :internal-search="true" placeholder="-- Pilih Salah Satu --"
                                :options="optSource" />
                        </div>
                    </b-col>
                    <b-col md="6" v-if="itemFlags.isPerhiasan">
                        <div>
                            <div class="font-weight-bold mt-3">Ada Cap</div>
                            <multiselect v-model="input.hasMark" label="name" :options="optBoolean" placeholder="-- Pilih Salah Satu --" />
                        </div>
                    </b-col>
                    <b-col md="6" v-if="itemFlags.isPerhiasan">
                        <div>
                            <div class="font-weight-bold mt-3">Tipe Emas</div>
                            <multiselect :disabled="fetch || !input.type" v-model="input.goldType" :allow-empty="false" label="name"
                                track-by="id" :internal-search="true" placeholder="-- Pilih Salah Satu --"
                                :options="goldTypes" />
                        </div>
                    </b-col>
                    <b-col md="6" class="mt-3">
                        <div>
                            <div class="font-weight-bold">Ada Kerusakan</div>
                            <multiselect v-model="input.isDamaged" label="name" :options="optBoolean" placeholder="-- Pilih Salah Satu --" />
                        </div>
                    </b-col>
                </b-row>
                <hr />

                <b-row class="mb-4" v-if="!itemFlags.isLMScan">
                    <b-col md="12">
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Kadar" class="font-weight-bold">
                                    <b-form-input
                                        id="purity"
                                        v-model="input.purity"
                                        :tabindex="1"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Berat Kotor" class="font-weight-bold">
                                    <b-input-group append="gr">
                                        <b-form-input
                                            id="dryWeight"
                                            v-model="input.dryWeight"
                                            :tabindex="2"
                                        />
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Berat Potongan" class="font-weight-bold">
                                    <b-input-group append="gr">
                                        <b-form-input
                                            id="weightReduction"
                                            v-model="input.weightReduction"
                                            :tabindex="3"
                                        />
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col md="6" v-if="itemFlags.isLMRetro">
                                <b-form-group label="No. Faktur Original" class="font-weight-bold">
                                    <b-form-input
                                        id="noFakturOriginal"
                                        v-model="input.noFakturOriginal"
                                        :tabindex="0"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <div class="mt-2" v-if="itemFlags.isPerhiasan">
                                    <div class="font-weight-bold">Merk Cap Emas</div>
                                    <multiselect
                                        :disabled="fetch || !input.type"
                                        v-model="input.goldMintMark"
                                        :allow-empty="false"
                                        label="name"
                                        track-by="id"
                                        :internal-search="true"
                                        placeholder="-- Pilih Salah Satu --"
                                        :options="goldMintMarks"
                                        :tabindex="4"
                                    />
                                </div>
                            </b-col>
                            <b-col md="6">
                                <template v-if="input.kind && !itemFlags.isLMRetro">
                                    <b-form-group label="Jumlah Keping" class="font-weight-bold">
                                        <b-input-group append="pcs">
                                            <b-form-input
                                                id="pieceCount"
                                                v-model="input.pieceCount"
                                                :tabindex="4"
                                            />
                                        </b-input-group>
                                    </b-form-group>
                                </template>
                            </b-col>
                             <b-col md="6" v-if="itemFlags.isPerhiasan">
                                <b-form-group label="No. Faktur Original" class="font-weight-bold">
                                    <b-form-input
                                        id="noFakturOriginal"
                                        v-model="input.noFakturOriginal"
                                    />
                                </b-form-group>
                            </b-col>
                             <b-col md="6" v-if="itemFlags.isPerhiasan">
                                <b-form-group label="Cap Getok" class="font-weight-bold">
                                    <multiselect
                                        class="font-weight-normal"
                                        v-model="input.isStamped"
                                        label="name"
                                        :options="optBoolean"
                                        placeholder="-- Pilih Salah Satu --"
                                    />
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>

                <b-row class="mb-4" v-if="itemFlags.isLMScan">
                    <b-col md="6">
                        <b-form-group label="No. Faktur Original" class="font-weight-bold">
                            <b-form-input
                                id="noFakturOriginal"
                                v-model="input.noFakturOriginal"
                                :tabindex="0"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group label="Tahun" class="font-weight-bold">
                            <b-form-select
                                v-model="input.year"
                                :options="yearOptions"
                            >
                                <template #first>
                                    <b-form-select-option :value="null">-- Pilih Tahun --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="6">
                         <b-form-group label="Modal">
                            <b-input-group prepend="Rp.">
                                <b-form-input id="modal" v-model="input.capital" maxlength="50"
                                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                    @input="sanitizeCapital" />
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row v-if="!itemFlags.isLMScan">
                    <b-col md="12">
                        <p class="font-weight-bold">
                            Berat Bersih: {{ netWeight }}
                        </p>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="12" class="text-right">
                        <b-button id="submit-barang" variant="success" :disabled="isSubmitting" @click="promptSubmit">
                            {{ isSubmitting ? "Menyimpan..." : "Submit Barang" }}
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>

        <b-modal id="m-barcode" title="Cetak Barcode" centered no-close-on-backdrop no-close-on-esc hide-footer
            hide-header-close>
            Silahkan cetak barcode dibawah ini. Mohon pastikan barcode tercetak dengan baik sebelum melanjutkan.
            <br /><br />
            <iframe id="barcode-iframe" :src="getBarcodeLink()" height="300px" width="100%" />
            <div class="mt-4">
                <b-row>
                    <b-col md="6">
                        <b-button variant="dark" :disabled="barcodeToggleCooldown" @click="toggleBarcodeType">
                            Print {{ barcodeType == 'barcode' ? 'Mini' : 'Barcode' }}
                        </b-button>
                    </b-col>
                    <b-col md="6" class="text-right">
                        <b-button id="finish-approval" variant="primary" @click="finishApproval">
                            Tutup
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'modal-input-barang-masuk-external',
    data() {
        return {
            initStatus: 0,
            isSubmitting: false,
            input: {
                kind: null,
                brand: null,
                type: null,
                purity: null,
                dryWeight: null,
                weightReduction: null,
                goldMintMark: null,
                goldType: null,
                pieceCount: null,
                source: null,
                hasMark: null,
                noFakturOriginal: null,
                isDamaged: false,
                isStamped: null,
                capital: null,
                year: null,
            },

            optSource: [
                { id: 4, name: "External" }
            ],
            optBoolean: [
                { value: true, name: "Ada" },
                { value: false, name: "Tidak Ada" }
            ],
            kinds: [],
            brands: [],
            types: [],
            goldMintMarks: [],
            goldTypes: [],
            fetch: false,

            barcodeLink: null,
            barcodeLinkMini: null,
            barcodeType: 'barcode',
            barcodeToggleCooldown: false,

        }
    },
    methods: {
        async init() {

            this.initStatus = 0

            await Promise.all([this.fetchJenisBarang(), this.fetchGoldMintMark(), this.fetchGoldType()])


            this.initStatus = 1
        },

        async fetchJenisBarang() {

            this.input.kind = null
            this.input.brand = null
            this.input.type = null
            this.input.source = null
            this.input.purity = null
            this.input.dryWeight = null
            this.input.weightReduction = null
            this.input.goldMintMark = null
            this.input.goldType = null
            this.input.pieceCount = null

            this.fetch = true
            await this.$axios.get('master/kinds?category=EMAS').then((res) => {
                // filter the options just show 'Perhiasan' and 'LM Retro'
                this.kinds = res.data.data.filter(item => item.id != 246 && item.id != 252)
            }).finally(() => {
                this.fetch = false
            })
        },

        async fetchMerkBarang() {

            this.input.brand = null
            this.input.type = null
            this.input.source = null
            this.input.purity = null
            this.input.dryWeight = null
            this.input.weightReduction = null
            this.input.goldMintMark = null
            this.input.goldType = null
            this.input.pieceCount = null

            this.fetch = true
            await this.$axios.get(`master/brands/${this.input.kind.id}`).then((res) => {
                this.brands = res.data.data
            }).finally(() => {
                this.fetch = false
            })
        },

        async fetchTipeBarang() {

            this.input.type = null
            this.input.source = null
            this.input.purity = null
            this.input.dryWeight = null
            this.input.weightReduction = null
            this.input.goldMintMark = null
            this.input.goldType = null
            this.input.pieceCount = null

            this.fetch = true
            await this.$axios.get(`master/types/${this.input.brand.id}`).then((res) => {
                this.types = res.data.data
            }).finally(() => {
                this.fetch = false
            })


        },

        async fetchGoldMintMark() {
            this.fetch = true
            await this.$axios.get('master/gold-mint-mark').then((res) => {
                this.goldMintMarks = res.data.data
            }).finally(() => {
                this.fetch = false
            })
        },

        async fetchGoldType() {
            this.fetch = true
            await this.$axios.get('master/gold-type').then((res) => {
                this.goldTypes = res.data.data
            }).finally(() => {
                this.fetch = false
            })
        },

        promptSubmit() {
            this.$bvModal.show("m-confirm-submit")
            this.postInsertExternal()
        },

        postInsertExternal() {

            // validate for each type
            const modes = {
                LMScan: [
                    { key: 'kind',         msg: 'Jenis Barang tidak boleh kosong' },
                    { key: 'brand',        msg: 'Merk Barang tidak boleh kosong' },
                    { key: 'type',         msg: 'Tipe Barang tidak boleh kosong' },
                    { key: 'source',       msg: 'Source tidak boleh kosong' },
                    { key: 'isDamaged', msg: 'Status Kerusakan harus dipilih' },
                    { key: 'capital',       msg: 'Modal tidak boleh kosong' },
                ],
                LMRetro: [
                    { key: 'kind',         msg: 'Jenis Barang tidak boleh kosong' },
                    { key: 'brand',        msg: 'Merk Barang tidak boleh kosong' },
                    { key: 'type',         msg: 'Tipe Barang tidak boleh kosong' },
                    { key: 'source',       msg: 'Source tidak boleh kosong' },
                    { key: 'purity',       msg: 'Kadar tidak boleh kosong' },
                    { key: 'dryWeight',    msg: 'Berat Kotor tidak boleh kosong' },
                    { key: 'weightReduction', msg: 'Berat Potongan tidak boleh kosong' },
                    { key: 'isDamaged', msg: 'Status Kerusakan harus dipilih' },
                    { key: 'capital',       msg: 'Modal tidak boleh kosong' },
                ],
                Perhiasan: [
                    { key: 'kind',         msg: 'Jenis Barang tidak boleh kosong' },
                    { key: 'brand',        msg: 'Merk Barang tidak boleh kosong' },
                    { key: 'type',         msg: 'Tipe Barang tidak boleh kosong' },
                    { key: 'source',       msg: 'Source tidak boleh kosong' },
                    { key: 'hasMark',      msg: 'Status Cap Tanda harus dipilih'},
                    { key: 'goldType',     msg: 'Tipe Emas tidak boleh kosong' },
                    { key: 'purity',       msg: 'Kadar tidak boleh kosong' },
                    { key: 'dryWeight',    msg: 'Berat Kotor tidak boleh kosong' },
                    { key: 'weightReduction', msg: 'Berat Potongan tidak boleh kosong' },
                    { key: 'goldMintMark', msg: 'Merk Cap Emas tidak boleh kosong' },
                    { key: 'pieceCount',   msg: 'Jumlah Keping tidak boleh kosong' },
                    { key: 'isDamaged', msg: 'Status Kerusakan harus dipilih' },
                    { key: 'isStamped', msg: 'Cap Getok harus dipilih' },
                    { key: 'capital',       msg: 'Modal tidak boleh kosong' },
                ],
            }

            const isValidValue = val => val !== null && val !== '';

            let ruleSet = null
            if (this.itemFlags.isLMScan)      ruleSet = modes.LMScan
            else if (this.itemFlags.isLMRetro) ruleSet = modes.LMRetro
            else if (this.itemFlags.isPerhiasan) ruleSet = modes.Perhiasan

            if (!ruleSet) {
                this.$helper.toastError(this, "Tipe Barang tidak valid")
                return
            }

            if (ruleSet) {
                for (const { key, msg } of ruleSet) {
                    const val = this.input[key]
                    if (!isValidValue(val)) {
                        this.$helper.toastError(this, msg)
                        return
                    }
                }
            }

            if (isValidValue(this.input.purity) && (this.input.purity < 1 || this.input.purity > 1000)) {
                this.$helper.toastError(this, "Kadar harus berada di antara 1 dan 1000")
                return
            }

            if (this.itemFlags.isLMRetro && isValidValue(this.input.purity) && (this.input.purity < 850 || this.input.purity > 1000)) {
                this.$helper.toastError(this, "Kadar untuk LM Retro harus berada di antara 850 dan 1000")
                return
            }

            const payload = {
                "type_id": this.input.type ? this.input.type.id : null,
                "purity": this.input.purity ? this.input.purity : null,
                "dry_weight": this.input.dryWeight ? this.input.dryWeight : null,
                "weight_reduction": this.input.weightReduction ? this.input.weightReduction : null,
                "gold_mark_id": this.input.goldMintMark ? this.input.goldMintMark.id : null,
                "gold_type_id": this.input.goldType ? this.input.goldType.id : null,
                "piece_count": this.input.pieceCount ? this.input.pieceCount : null,
                "source": this.input.source ? this.input.source.id : null,
                "has_mark": this.input.hasMark ? this.input.hasMark.value : null,
                "no_faktur_original": this.input.noFakturOriginal,
                "is_damaged": this.input.isDamaged.value,
                "is_stamped": this.input.isStamped ? this.input.isStamped.value : null,
                "capital": this.input.capital ? this.input.capital.replace(/\./g, "") : null,
                "year": this.input.year || null,
            }

            this.isSubmitting = true
            this.$axios.post("delivery/insert-external-gold", payload).then((res) => {
                this.$bvModal.hide("m-input-barang-masuk-external-emas")
                this.$emit("refresh")
                this.clearInput()

                this.barcodeLink = res.data.data.link
                this.barcodeLinkMini = res.data.data.link_mini
                this.$bvModal.show('m-barcode')

            }).catch(error => {
                // error message validate laravel
                if (error.response.status == 422) {
                    this.$helper.toastError(this, error.response.data.message)
                }
                else {
                    this.$helper.parseError(this, error)
                }
            })
            .finally(() => this.isSubmitting = false)
        },

        clearInput() {
            this.input = {
                kind: null,
                brand: null,
                type: null,
                purity: null,
                dryWeight: null,
                weightReduction: null,
                goldMintMark: null,
                goldType: null,
                pieceCount: null,
                source: null,
                year: null,
            }
        },

        getBarcodeLink() {
            if (this.barcodeType == 'mini') {
                return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeLinkMini}`
            }
            return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeLink}`
        },

        toggleBarcodeType() {
            this.barcodeToggleCooldown = true
            if (this.barcodeType == 'barcode') this.barcodeType = 'mini'
            else this.barcodeType = 'barcode'
            setTimeout(function () {
                this.barcodeToggleCooldown = false
            }.bind(this), 2000);
        },

        finishApproval() {
            this.$bvModal.hide('m-barcode')
            this.$emit("approved")
        },

        sanitizeCapital() {
            let cleaned = String(this.input.capital).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.input.capital = res
        },

        sanitizePriceAtPawn() {
            let cleaned = String(this.input.priceAtPawn).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.input.priceAtPawn = res
        },

        sanitizeAdjGrade() {
            let cleaned = String(this.input.adjGrade).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.input.adjGrade = res
        },

        sanitize(item) {
            let cleaned = String(item.adjustment).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            item.adjustment = res
        },

    },
    mounted() {
        // this.init()
    },
    computed: {
        yearOptions() {
            const current = new Date().getFullYear();
            const years = [];
            for (let y = current; y >= 2000; y--) {
                years.push(String(y));
            }
            return years;
        },
        hasYear() {
            if (!this.typeId) return null;
            return this.typeId.has_year;
        },
        itemFlags() {
            return {
                isLMRetro: this.input.kind && this.input.kind.id === 261,
                isLMScan: this.input.kind && this.input.kind.id === 251,
                isPerhiasan: this.input.kind && this.input.kind.id === 257,
            };
        },
        netWeight() {
            return `${(this.input.dryWeight - this.input.weightReduction).toFixed(2)} gr`;
        }
    },
}
</script>
